// Images marked data-hide-on-error (game icons) disappear if they fail to load, rather than showing a broken image.
// Load errors don't bubble, so this listens as they travel down to the image. The bundle runs in the <head>, before
// any image on the page exists, so it never misses one.
document.addEventListener('error', (e) => {
  const image = e.target
  if (image instanceof HTMLImageElement && image.hasAttribute('data-hide-on-error')) {
    image.style.display = 'none'
  }
}, true)
